import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  temperatures: [],
  temperatureType: "celsius",
};

export const templateSlice = createSlice({
  name: "temperature",
  initialState,
  reducers: {
    setTemperatures: (state, action) => {
      state.temperatures = action.payload;
    },
    getTemperature: (state, action) => {
      state.temperatures = action.payload;
    },
    setTemperatureType: (state, action) => {
      state.temperatureType = action.payload;
    },
  },
});

export const { setTemperatures, setTemperatureType } = templateSlice.actions;

export default templateSlice.reducer;
